/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { FormGroup, FormControl, Validators } from '@angular/forms';

import {
  SheetMetalFittingSizeDto, FittingDto, ActionTypeEnumDto,
  CreateSheetMetalSizeInfoDto, CreateSheetMetalFittingSizeInfoDto
} from 'api/models';
import { GenericMapper } from './GenericMapper';


export class SheetMetalFittingSizeMapper implements GenericMapper {


  createAddSizeObject(
    dataArray: SheetMetalFittingSizeDto[],
    userID: string, selectedFitting: FittingDto,
    statusId: ActionTypeEnumDto): any {

    const createSizeList: CreateSheetMetalSizeInfoDto[] = [];
    let maxID = 0;
    dataArray.forEach(element => {
      element.id = element.id > 0 ? element.id : maxID++;
      const newSize: CreateSheetMetalSizeInfoDto = {
        bdid: element.bdid,
        id: element.id,
        sizeID: element.sizeID,
        sizeID2: element.sizeID2 ? element.sizeID2 : 0,
        nominalSize: element.nominalSize,
        nominalSize2: element.nominalSize2,

      };
      createSizeList.push(newSize);
    });

    const createfittingSizeInfo: CreateSheetMetalFittingSizeInfoDto = {
      fittingEntryID: selectedFitting.fittingEntryID,
      fittingIDNumber: selectedFitting.fittingIDNumber,
      comment: 'New added size',
      bdToolID: selectedFitting.bdToolID,
      changeby: userID,
      actionType: statusId,
      sizeList: createSizeList
    };
    return createfittingSizeInfo;
  }


  mapToFormGroup(source: SheetMetalFittingSizeDto): FormGroup {
    const formGroup = new FormGroup({
      id: new FormControl(source.id),
      isDiscontinued: new FormControl(source.isDiscontinued),
      isPartialySaved: new FormControl(source.isPartialySaved),
      nominalSize: new FormControl({ value: source.nominalSize, disabled: true }, Validators.required),
      bdid: new FormControl({ value: source.bdid, disabled: true }, Validators.required),
      sizeID: new FormControl({ value: source.sizeID, disabled: source.isPartialySaved }, Validators.required),
      sizeID2: new FormControl({ value: source.sizeID2, disabled: source.isPartialySaved }, Validators.required),
      decSize: new FormControl({ value: source.decSize, disabled: true }, Validators.required),
    });
    return formGroup;
  }

  mapToObject(controls): SheetMetalFittingSizeDto {
    const newObject = {
      id: controls[`id`].value,
      isDiscontinued: controls[`isDiscontinued`].value,
      isPartialySaved: controls[`isPartialySaved`].value,
      nominalSize: controls[`nominalSize`].value,
      bdid: controls[`bdid`].value ? controls[`bdid`].value : 0,
      sizeID: controls[`sizeID`].value.sizeID,
      sizeID2: controls[`sizeID2`].value.sizeID,
      decSize: controls[`decSize`].value,
    } as SheetMetalFittingSizeDto;

    return newObject;
  }

  getTableHeaders(): any {
    return {
      nominalSize: 'Nominal Size',
      sizeID: 'Size 1',
      sizeID2: 'Size 2',
      bdid: 'BDID',
      decSize: 'Dec Size',

    };
  }
  setDefaultValues(elementForm: FormGroup, baseObject: SheetMetalFittingSizeDto, selectedFitting: FittingDto) {
    elementForm.controls[`nominalSize`].setValue((String)(baseObject.sizeID + 'X' + baseObject.sizeID2));
    elementForm.controls[`decSize`].setValue(baseObject.decSize);
    if (elementForm.controls[`sizeID`].value === elementForm.controls[`sizeID2`].value) {
      elementForm.controls[`bdid`].setValue((String)(selectedFitting.fittingIDNumber + elementForm.controls[`sizeID`].value.sizeID));

    } else {

      elementForm.controls[`bdid`].setValue((String)(selectedFitting.fittingIDNumber +
        elementForm.controls[`sizeID`].value.sizeID + elementForm.controls[`sizeID2`].value.sizeID));
    }
  }

  setValuesByElement(elementForm: FormGroup, baseObject: SheetMetalFittingSizeDto, selectedNominalSize: any, isPartialySaved?: boolean) {
    const firstSelectedList = selectedNominalSize.find(x => x.sizeID === baseObject.sizeID);
    const secondSelectedlist = selectedNominalSize.find(x => x.sizeID === baseObject.sizeID2);
    elementForm.controls[`id`].setValue(baseObject.id);
    elementForm.controls[`isDiscontinued`].setValue(baseObject.isDiscontinued);
    elementForm.controls[`isPartialySaved`].setValue(baseObject.isPartialySaved);
    elementForm.controls[`nominalSize`].setValue(baseObject.nominalSize);
    elementForm.controls[`bdid`].setValue(baseObject.bdid);
    elementForm.controls[`decSize`].setValue(baseObject.decSize);
    elementForm.controls[`sizeID`].setValue(firstSelectedList);
    elementForm.controls[`sizeID2`].setValue(secondSelectedlist);
  }
}
